"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConvertValueNodeToString = exports.ConvertValueToEditableString = exports.ConvertStringToObject = void 0;
const graphql_zeus_1 = require("graphql-zeus");
const TemplateUtils_1 = require("graphql-zeus/lib/TreeToGraphQL/templates/TemplateUtils");
exports.ConvertStringToObject = (value) => {
    const computeString = `
    scalar Translatable
    input Translate{
        field: Translatable = ${value}
    }
`;
    const TranslatedString = graphql_zeus_1.Parser.parse(computeString);
    const translationNode = TranslatedString.nodes.find((n) => n.name === 'Translate');
    if (!translationNode || !translationNode.args) {
        return;
    }
    return translationNode.args[0].args;
};
exports.ConvertValueToEditableString = (f) => {
    const TranslatedString = TemplateUtils_1.TemplateUtils.resolverForConnection(f);
    return TranslatedString;
};
exports.ConvertValueNodeToString = (node) => {
    var _a;
    if (!node.args) {
        return '';
    }
    if ((_a = node.type.options) === null || _a === void 0 ? void 0 : _a.includes(graphql_zeus_1.Options.array)) {
        if (node.args.length === 0) {
            return '[]';
        }
        return exports.ConvertValueToEditableString(node).split('=')[1];
    }
    if (node.args.length === 0) {
        return '';
    }
    return exports.ConvertValueToEditableString(node).split('=')[1];
};
